export default __webpack_public_path__ + "static/media/mum2.19e61eee.png";